import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SelfService {

    constructor(
        protected http: HttpClient
    ) { }

    supplierPublicDetail(token: string):Observable<any>{
        return this.http.get(`/public/pages/supplier?token=${token}`);
    }

    verifySupplier(token: string):Observable<any>{
        return this.http.get(`/public/verify/supplier?token=${token}`);
    }

    getPublicTraceQRDetail(body: any):Observable<any>{
        let payload = JSON.stringify(body);
        return this.http.post('/trace-qr/trace-lot/get-public-trace-qr-detail', payload);
    }

    getPublicMarketplaceItemQRDetail(body: any):Observable<any>{
        let payload = JSON.stringify(body);
        return this.http.post('/marketplace/items-qr/get-public-marketplace-item-qr-detail', payload);
    }

    getPublicHarvestLotQRDetail(body: any):Observable<any>{
        let payload = JSON.stringify(body);
        return this.http.post('/harvest/get-public-harvest-lot-detail', payload);
    }

    getPublicHarvestLotQRDetailByLotNo(body: any):Observable<any>{
        let payload = JSON.stringify(body);
        return this.http.post('/harvest/get-public-harvest-lot-detail-by-lotno', payload);
    }

    getPublicPackedProductQRDetail(body: any):Observable<any>{
        let payload = JSON.stringify(body);
        return this.http.post('/sales/product-packing/get-public-packed-product-detail', payload);
    }

    getMarketplaceLinkItems(link: any, data = {}):Observable<any>{
        return this.http.post(`/marketplace/links/get-link-items/${link}`, data);
    }

    getPublicProductionBatchBookletDetail(id: any):Observable<any>{
        return this.http.get(`/production-process/production-batch-booklet/get-public-batch-booklet-details/${id}`);
    }
      
}
